import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { canActivate } from '@angular/fire/auth-guard';
import { onlyPermissions, redirectUnauthorizedToLogin } from 'projects/shared-lib/src/core/permissions/guard-utils';

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled'
};

const routes: Routes = [
  {
    path: '', component: AppLayoutComponent, ...canActivate(redirectUnauthorizedToLogin),
    children:[
      { path: 'projects', data: { breadcrumb: 'LABEL.PROJECTS' }, loadChildren: () => import('@private/projects/projects.module').then(m => m.ProjectsModule) },
      { path: 'settings', ...canActivate(onlyPermissions(['canAdmin', 'editProjects'])), data: { breadcrumb: 'LABEL.SETTINGS' }, loadChildren: () => import('./modules/private/settings/settings.module').then(m => m.SettingsModule) },
      // { path: 'lab', loadChildren: () => import('./modules/private/lab/lab.module').then(m => m.LabModule) },
      { path: '',   redirectTo: 'projects',  pathMatch: 'full'  }, // redirect to
    ]
  },
  { path: 'home', loadChildren: () => import('@public/landing/landing.module').then(m => m.LandingModule) },
  { path: 'login', data: { breadcrumb: 'Login' }, loadChildren: () => import('@public/login/login.module').then(m => m.LoginModule) },
  { path: 'au', data: { breadcrumb: 'Authentication Verification' }, loadChildren: () => import('@public/auth-verify/auth-verify.module').then(m => m.AuthVerifyModule) },
  { path: 'forgotpassword', data: { breadcrumb: 'Login' }, loadChildren: () => import('@public//forgotpassword/forgotpassword.module').then(m => m.ForgotPasswordModule) },
  { path: 'notfound', loadChildren: () => import('@public/notfound/notfound.module').then(m => m.NotfoundModule) },
  { path: '**',   redirectTo: '', pathMatch: 'full' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
